import module from '@kendu/ui/module'
import { element } from 'angular'

export class KdElementScrollClipService {
  constructor ($window) {
    this.defaultContainer = $window.document.body
    this.$window = $window
  }

  create (element) {
    const parent = this.findContainer(element)
    let resizeObserver = null
    let scrollTop = null
    let scrolled = false

    const render = () => {
      let eTop = this.getOffset(element[0], parent[0])
      let eHeight = element[0].clientHeight
      let pTop = this.getOffset(parent[0])
      let pHeight = parent[0].scrollHeight
      let wHeight = this.$window.innerHeight
      let vHeight = Math.round(wHeight - pTop)
      let marginTop = Math.max(0, Math.min(vHeight - eHeight, eTop))
      let marginBottom = Math.max(0, Math.min(vHeight - eHeight, pHeight - eTop - eHeight))
      let pClip = Math.max(marginTop + eHeight + marginBottom, vHeight)
      let pScroll = eTop - marginTop

      this.$window.requestAnimationFrame(() => {
        parent[0].style.height = `${pClip}px`
        parent[0].scroll(0, pScroll)

        if (!scrolled) {
          this.$window.scroll(0, scrollTop - pScroll)
          scrolled = true
        }
      })
    }

    const enable = () => {
      if (!this.$window.ResizeObserver) return

      scrollTop = this.$window.scrollY
      scrolled = false

      parent.css('overflow', 'hidden')

      this.$window.addEventListener('resize', render)
      resizeObserver = new this.$window.ResizeObserver(render)

      resizeObserver.observe(element[0])
    }

    const disable = () => {
      if (!resizeObserver) return

      resizeObserver.unobserve(element[0])
      resizeObserver = null

      this.$window.removeEventListener('resize', render)

      let scrollTop = parent[0].scrollTop + this.$window.scrollY

      parent.css('overflow', null)
      parent.css('min-height', null)
      parent.css('height', null)

      this.$window.scroll(0, scrollTop)
    }

    element.on('destroy', disable)

    return {enable, disable}
  }

  getOffset (element, parent) {
    let offset = 0

    while (element && element !== parent && !isNaN(element.offsetTop)) {
      offset += element.offsetTop

      element = element.offsetParent
    }

    return offset
  }

  findContainer (node) {
    return element(node[0].closest('kd-content') || this.defaultContainer)
  }
}

module.service('KdElementScrollClipService', KdElementScrollClipService)



// WEBPACK FOOTER //
// ./src/kendu/ui/services/KdElementScrollClip.js